export enum EnrollmentState {
  INITIAL,
  TERMS_ACCEPTED,
  ENROLLMENT_ACCEPTED,
}

export enum OTCErrors {
  TIMEOUT = 'OTC_TIMEOUT',
  ALREADY_VERIFIED = 'OTC_ALREADY_VERIFIED',
  NOT_PRESENT = 'OTC_NOT_PRESENT',
  GENERAL_ERROR = 'OTC_GENERAL_ERROR',
  CONFIG_NOT_FOUND = 'CONFIG_NOT_FOUND',
}

export type UserAccountForm = {
  emailAddress: string;
};
